import React from 'react';
import ReactDOM from 'react-dom/client';
import RootApp from './RootApp';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.Fragment>
    <RootApp />
  </React.Fragment>
);
